module.exports = __webpack_public_path__ + "static/img/Ron-McFetridge_Waterforce_CS.9439658.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/Ron-McFetridge_Waterforce_CS.jpg
// module id = 13Wb
// module chunks = 0